"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.game = exports.ATGame = exports.ATAchievements = void 0;
const ATMainScene_1 = require("./ATMainScene");
const ATPreloadScene_1 = require("./ATPreloadScene");
const KHPersistentReference_1 = require("./KH/References/KHPersistentReference");
const KHGame_1 = require("./KH/KHGame");
const KHAchievements_1 = require("./KH/KHAchievements");
const ATGameScene_1 = require("./ATGameScene");
const ATAudioScene_1 = require("./ATAudioScene");
const config = {
    type: Phaser.AUTO,
    scale: {
        width: 960,
        height: 600,
    },
    input: {
        gamepad: true,
        mouse: {
            preventDefaultWheel: false
        },
    },
    parent: "phaser-game",
    dom: {
        createContainer: true
    },
    version: "1.0.0",
    scene: [ATPreloadScene_1.ATPreloadScene, ATMainScene_1.ATMainScene, ATGameScene_1.ATGameScene, ATAudioScene_1.ATAudioScene]
};
var ATAchievements;
(function (ATAchievements) {
    ATAchievements["Win"] = "attention_win";
})(ATAchievements = exports.ATAchievements || (exports.ATAchievements = {}));
class ATGame extends KHGame_1.KHGame {
    constructor(config, khConfig) {
        super(config, khConfig);
        this.width = Number(this.config.width);
        this.height = Number(this.config.height);
        this.achievements = new KHAchievements_1.default();
        this.score = new KHPersistentReference_1.KHPersistentReference(0, true);
        this.scoreCalm = new KHPersistentReference_1.KHPersistentReference(0, true);
        this.mute = new KHPersistentReference_1.KHPersistentReference(false, true);
        this.storageManager.registerAll({
            [KHAchievements_1.default.MENAGERIE_KEY]: this.achievements
        });
    }
    fontName() {
        return "SourceSerif";
    }
    fontStyle(size) {
        return `font: ${size}px ${this.fontName()}; font-variant-numeric: tabular-nums; user-select: none;`;
    }
    fontStyleWithColor(size, color) {
        return `font: ${size}px ${this.fontName()}; font-variant-numeric: tabular-nums; user-select: none; color: #${Math.floor(color).toString(16)}`;
    }
}
exports.ATGame = ATGame;
exports.game = new ATGame(config, { scaleMode: KHGame_1.KHScaleMode.NoScale, alwaysMaxScale: true });
